var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Paper as MuiPaper, ClickAwayListener } from '@material-ui/core';
import Popper from '@material-ui/core/Popper';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        zIndex: theme.zIndex.modal,
        width: 'max-content',
    },
    portal: {
        // popperのhideへの対応。
        // portalでboundariesElement外にスクロールされたときに適切に要素を隠す。
        '&[x-out-of-boundaries]': {
            display: 'none',
            visibility: 'hidden',
            pointerEvents: 'none',
        },
    },
    paper: {
        backgroundColor: theme.palette.light.background.paper,
        boxShadow: theme.shadows[2],
        overflowY: 'auto',
        color: theme.palette.light.text.primary,
    },
    padding: {
        padding: theme.spacing(2),
    },
    rounded: {
        borderRadius: theme.shape.borderRadius,
    },
}); }, { name: 'SnPopup' });
/**
 * ポップアップコンポーネント。
 */
export var Popup = function (props) {
    var _a, _b;
    // 型定義的には`others`に要素は1つもないが、UiKitを利用するプロジェクトで付与されるカスタムデータ属性を引き渡すために`others`を使用している。
    var open = props.open, anchorEl = props.anchorEl, onClickAway = props.onClickAway, children = props.children, placement = props.placement, width = props.width, maxHeight = props.maxHeight, rounded = props.rounded, style = props.style, className = props.className, _c = props.preventOverflow, preventOverflow = _c === void 0 ? false : _c, _d = props.flip, flip = _d === void 0 ? true : _d, _e = props.boundariesElement, boundariesElement = _e === void 0 ? 'scrollParent' : _e, _f = props.portal, portal = _f === void 0 ? false : _f, classesProp = props.classes, others = __rest(props, ["open", "anchorEl", "onClickAway", "children", "placement", "width", "maxHeight", "rounded", "style", "className", "preventOverflow", "flip", "boundariesElement", "portal", "classes"]);
    var handleClickAway = useCallback(function (event) {
        // クリックした要素がanchorElに内包されているとき、onClickAwayは呼び出さない。
        // @ts-ignore: 型がoverlapしていないためエラーが出るが、実際はどちらもDOMの参照なので無視する。
        if (!(anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.contains(event.target)))
            onClickAway === null || onClickAway === void 0 ? void 0 : onClickAway(event);
    }, [onClickAway, anchorEl]);
    var popperModifier = useMemo(function () { return ({
        preventOverflow: {
            enabled: preventOverflow,
            boundariesElement: boundariesElement,
        },
        flip: {
            enabled: flip,
            flipVariationsByContent: true,
            boundariesElement: boundariesElement,
        },
    }); }, [preventOverflow, flip, boundariesElement]);
    var classes = useStyles({ classes: classesProp });
    var rootClassName = classNames(classes.root, (_a = {},
        _a[classes.portal] = portal,
        _a));
    var paperClassName = classNames(className, classes.paper, (_b = {},
        _b[classes.rounded] = rounded,
        _b));
    var paperOverrideStyle = useMemo(function () {
        if (maxHeight == null && width == null)
            return style;
        return __assign({ width: width, maxHeight: maxHeight }, style);
    }, [maxHeight, style, width]);
    return (React.createElement(Popper, __assign({ open: open, anchorEl: anchorEl, placement: placement !== null && placement !== void 0 ? placement : 'bottom', modifiers: popperModifier, className: rootClassName, disablePortal: !portal }, others),
        React.createElement(ClickAwayListener, { onClickAway: handleClickAway, touchEvent: "onTouchStart" },
            React.createElement(MuiPaper, { className: paperClassName, style: paperOverrideStyle, square: true },
                React.createElement("div", null, children)))));
};
